module.exports = __webpack_public_path__ + "img/category-popular-hover.f54af851.png";